export function formatDate(date) {
  const options = { year: 'numeric', month: 'short', day: '2-digit' }
  if (date) {
    date = new Date(date)
    return date.toLocaleDateString('en-US', options)
  } else {
    return ''
  }
}

export function formatMonth(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`
}

export function getYearMonthListSince(targetDateStr) {
  const result = [];
  const targetDate = new Date(targetDateStr);
  const currentDate = new Date();

  // Set both to the first of the month to normalize
  targetDate.setDate(1);
  currentDate.setDate(1);

  while (targetDate <= currentDate) {
    result.push(formatMonth(targetDate));
    targetDate.setMonth(targetDate.getMonth() + 1);
  }

  return result;
}

export function formatTo12Hour(timeStr) {
  const [hourStr, minuteStr] = timeStr.split(':');
  let hour = parseInt(hourStr, 10);
  const suffix = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return minuteStr !== '00' ? `${hour}:${minuteStr}${suffix}` : `${hour}${suffix}`;
}

function formatTime(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return m === 0 ? `${hour12}${ampm}` : `${hour12}:${String(m).padStart(2, '0')}${ampm}`;
}

export function formatTimeRange({ start, end }) {
  return `${formatTo12Hour(start)} - ${formatTo12Hour(end)}`;
}

function minutesToDate(minutes, baseDate) {
  const d = new Date(baseDate);
  d.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
  return d;
}

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

export function getBusinessStatus(businessHours, date = new Date()) {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const nowDay = days[date.getDay()];
  const nowTime = date.getHours() * 60 + date.getMinutes(); // in minutes

  // Check today's intervals
  const intervals = businessHours[nowDay] || [];
  for (let interval of intervals) {
    const [startH, startM] = interval.start.split(':').map(Number);
    const [endH, endM] = interval.end.split(':').map(Number);
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    if (nowTime >= startMinutes && nowTime < endMinutes) {
      return {
        isOpen: true,
        nextChange: minutesToDate(endMinutes, date),
        closingTime: formatTime(endMinutes),
        status: `Open now, closes at ${formatTime(endMinutes)}`
      };
    }
  }

  // If closed, find the next opening time
  for (let offset = 0; offset < 7; offset++) {
    const checkDate = new Date(date);
    checkDate.setDate(date.getDate() + offset);
    const checkDay = days[checkDate.getDay()];
    const dayIntervals = businessHours[checkDay] || [];

    for (let interval of dayIntervals) {
      const [startH, startM] = interval.start.split(':').map(Number);
      const startMinutes = startH * 60 + startM;

      // If today, only consider future intervals
      if (offset === 0 && startMinutes <= nowTime) continue;

      const dayLabel = offset === 0 ? "today" : `on ${capitalize(checkDay)}`;
      const dayKey = offset === 0 ? "today" : checkDay;
      return {
        isOpen: false,
        nextChange: minutesToDate(startMinutes, checkDate),
        dayKey: dayKey,
        openingTime: formatTime(startMinutes),
        status: `Closed now, opens ${dayLabel} at ${formatTime(startMinutes)}`
      };
    }
  }

  return {
    isOpen: false,
    nextChange: null,
    closedWeek: true,
    status: "Closed all week"
  };
}